var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", lg: "8" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title-buy-prices")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c(
                            "w-row",
                            { attrs: { "no-wrap": "", center: "" } },
                            [
                              _vm.isLoaded && _vm.sellerTabs.length > 0
                                ? _c("w-tabs", {
                                    attrs: { tabs: _vm.sellerTabs },
                                    model: {
                                      value: _vm.openedSeller,
                                      callback: function ($$v) {
                                        _vm.openedSeller = $$v
                                      },
                                      expression: "openedSeller",
                                    },
                                  })
                                : _c("span", { staticClass: "no-suppliers" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$ct("there-are-no-suppliers-yet")
                                      )
                                    ),
                                  ]),
                              _c("w-spacer"),
                              _c(
                                "w-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: _vm.$ct("tooltip.add-supplier"),
                                      expression: "$ct('tooltip.add-supplier')",
                                    },
                                  ],
                                  style: { flexShrink: 0 },
                                  attrs: { round: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addClicked()
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "plus" } })],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.supplier
                    ? [
                        _c(
                          "w-row",
                          { style: { zIndex: 100 } },
                          [
                            _c(
                              "w-col",
                              { attrs: { md: "6", xs: "12" } },
                              [
                                _c("app-contact-search", {
                                  attrs: {
                                    disabled: !_vm.canHaveSupplier,
                                    "group-id": _vm.groupId,
                                    label: _vm.$ct("labels.sellerName"),
                                    value: _vm.supplierContact,
                                    fancy: "",
                                    "auto-focus": _vm.autoFocus,
                                    "show-supplier-switch": "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.contactClicked($event)
                                    },
                                    "update-group": function ($event) {
                                      _vm.groupId = $event
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "w-col",
                              { attrs: { md: "6", xs: "12" } },
                              [
                                _vm.supplier
                                  ? _c("w-checkbox", {
                                      style: { alignSelf: "baseline" },
                                      attrs: {
                                        value: _vm.supplier.IsMainSupplier,
                                        label: _vm.$ct("labels.isMainSupplier"),
                                        reverse: false,
                                        space: "",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.onMainSupplierChange(
                                            $event
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "w-row",
                          [
                            _c(
                              "w-col",
                              { attrs: { md: "6", xs: "12" } },
                              [
                                _c("w-input", {
                                  attrs: {
                                    label: _vm.$ct("labels.codeManufacturer"),
                                    fancy: "",
                                  },
                                  model: {
                                    value: _vm.supplier.ManufacturerCode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.supplier,
                                        "ManufacturerCode",
                                        $$v
                                      )
                                    },
                                    expression: "supplier.ManufacturerCode",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "w-col",
                              { attrs: { md: "6", xs: "12" } },
                              [
                                _c("w-input", {
                                  attrs: {
                                    label: _vm.$ct("labels.codeSupplier"),
                                    fancy: "",
                                  },
                                  model: {
                                    value: _vm.supplier.SupplierCode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.supplier,
                                        "SupplierCode",
                                        $$v
                                      )
                                    },
                                    expression: "supplier.SupplierCode",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.canSeeSellPrices
                          ? _c(
                              "w-row",
                              [
                                _c(
                                  "w-col",
                                  {
                                    style: { flexDirection: "row" },
                                    attrs: { md: "5", xs: "6" },
                                  },
                                  [
                                    _vm.isAllowedMultiValuta
                                      ? _c("app-currency-select", {
                                          staticClass: "mrs",
                                          attrs: { fancy: "" },
                                          model: {
                                            value: _vm.supplier.CurrencyID,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.supplier,
                                                "CurrencyID",
                                                $$v
                                              )
                                            },
                                            expression: "supplier.CurrencyID",
                                          },
                                        })
                                      : _vm._e(),
                                    _c("w-input-number", {
                                      style: { flexGrow: 1 },
                                      attrs: {
                                        label: _vm.$ct("labels.catalogPrice"),
                                        value: _vm.catalogPrice,
                                        fancy: "",
                                        decimals: _vm.decimals,
                                      },
                                      on: {
                                        focus: function ($event) {
                                          _vm.focus = "cat"
                                        },
                                        input: function ($event) {
                                          return _vm.catalogPriceChanged($event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "w-col",
                                  { attrs: { md: "2", xs: "6" } },
                                  [
                                    _c("w-input-number", {
                                      attrs: {
                                        value: _vm.percentage,
                                        fancy: "",
                                        label: "- %",
                                      },
                                      on: {
                                        focus: function ($event) {
                                          _vm.focus = "percent"
                                        },
                                        input: function ($event) {
                                          return _vm.percentageChanged($event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "w-col",
                                  { attrs: { md: "5", xs: "12" } },
                                  [
                                    _c("w-input-number", {
                                      attrs: {
                                        label: _vm.$ct("labels.nettoPrice"),
                                        value: _vm.nettoPrice,
                                        fancy: "",
                                        decimals: _vm.decimals,
                                      },
                                      on: {
                                        focus: function ($event) {
                                          _vm.focus = "netto"
                                        },
                                        input: function ($event) {
                                          return _vm.nettoPriceChanged($event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "w-row",
                          { style: { zIndex: 50 } },
                          [
                            _c(
                              "w-col",
                              { attrs: { xs: "12" } },
                              [
                                _c("w-input-autocomplete", {
                                  attrs: {
                                    label: _vm.$ct("labels.brand"),
                                    "empty-on-focus": "",
                                    fancy: "",
                                  },
                                  model: {
                                    value: _vm.supplier.Brand,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.supplier, "Brand", $$v)
                                    },
                                    expression: "supplier.Brand",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "w-row",
                          [
                            _c(
                              "w-col",
                              { attrs: { xs: "3" } },
                              [
                                _c("w-input-number", {
                                  attrs: {
                                    label: _vm.$ct("labels.min-order-qty"),
                                    fancy: "",
                                  },
                                  model: {
                                    value: _vm.supplier.MinOrderQty,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.supplier, "MinOrderQty", $$v)
                                    },
                                    expression: "supplier.MinOrderQty",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "w-row",
                          { attrs: { "no-margin": "" } },
                          [
                            _c("w-spacer"),
                            _c(
                              "w-button",
                              {
                                staticClass: "danger",
                                attrs: { icon: "trash" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeClicked()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$ct("labels.remove")) + " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "w-modal",
                {
                  model: {
                    value: _vm.missingModule,
                    callback: function ($$v) {
                      _vm.missingModule = $$v
                    },
                    expression: "missingModule",
                  },
                },
                [
                  _c("app-missing-module-modal", {
                    attrs: { "module-id": 45 },
                    on: {
                      close: function ($event) {
                        _vm.missingModule = false
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", lg: "4" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("common.settings")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct(
                                "buy-price-is-computed-from-composition"
                              ),
                            },
                            model: {
                              value: _vm.product.BuyPriceComesFromComposition,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.product,
                                  "BuyPriceComesFromComposition",
                                  $$v
                                )
                              },
                              expression:
                                "product.BuyPriceComesFromComposition",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.product.BuyPriceComesFromComposition
                        ? _c("w-col", { attrs: { xs: "12" } }, [
                            _vm._v(
                              " €" +
                                _vm._s(
                                  _vm.product.getBuyPriceFromComposition()
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }